import type { Statut } from '@/lib/types';
import { STATUT_LABELS } from '@/lib/types';

const STATUT_CLASSES: Record<Statut, string> = {
  CONFIRME: 'bg-status-confirme-bg text-status-confirme-text',
  EN_ATTENTE: 'bg-status-en-attente-bg text-status-en-attente-text',
  EN_COURS: 'bg-status-en-cours-bg text-status-en-cours-text',
  ATTENTE_PIECES: 'bg-status-attente-pieces-bg text-status-attente-pieces-text',
  TERMINE: 'bg-status-termine-bg text-status-termine-text',
  LIVRE: 'bg-status-livre-bg text-status-livre-text',
  ANNULE: 'bg-status-annule-bg text-status-annule-text',
};

type Props = {
  statut: Statut;
};

export default function StatusBadge({ statut }: Props) {
  return (
    <span
      className={`inline-flex items-center px-2 py-1 rounded-sm text-xs font-bold uppercase tracking-wide ${STATUT_CLASSES[statut]}`}
    >
      {STATUT_LABELS[statut]}
    </span>
  );
}

export function UrgentBadge() {
  return (
    <span className="inline-flex items-center px-2 py-1 rounded-sm text-xs font-bold uppercase tracking-wide bg-status-urgent-bg text-status-urgent-text">
      🔥 Urgent
    </span>
  );
}
